<template>
  <div class="content" :class="`${curLang} ${contentClass}`">
    <router-view v-slot="{ Component, route }">
      <transition name="fade" mode="out-in">
        <component :is="Component" :key="route.path" />
      </transition>
    </router-view>
  </div>
</template>

<script setup>
import { ref, computed, onMounted, provide, nextTick, watch } from "vue";
import {
  getUrlParams,
  getParam,
  getUserJsonApi,
  getActivityApi,
  isPortrait,
} from "@utils";
import { getJSON } from "@api/request";
import LanguageHook from "@hooks/language";
const { curLang, langData, getLangCode, addMeta } = LanguageHook();
const platform = ref(8);

const gameId = ref(386);
const isLogin = ref(false);
const accountName = ref("");
const isMobile = ref(isPortrait());
// 获取URL参数决定初始页面
const getInitialPage = () => {
  const mainPage = getParam("mainPage");
  const supportedPages = ["home", "ugc", "center"];

  // 如果参数存在且在支持列表中，返回该参数，否则返回home
  if (mainPage && supportedPages.includes(mainPage)) {
    return mainPage;
  }
  return "home";
};

const activeNavTab = ref(getInitialPage()); // 当前激活的导航: home-首页, ugc-UGC列表, center-创作中心
const viewPageStartTime = ref(null);
const contentClass = ref("");
const initClass = () => {
  if (isMobile.value) {
    contentClass.value = `mobile-${activeNavTab.value}`;
    document
      .getElementById("app")
      .classList.remove(
        "mobile-home",
        "mobile-ugc",
        "mobile-center",
        "mobile-com",
        "mobile-development",
        "mobile-feedback",
        "home",
        "ugc",
        "center",
        "com",
        "development",
        "feedback"
      );
    document.getElementById("app").classList.add(contentClass.value);
  } else {
    contentClass.value = `${activeNavTab.value}`;
    document
      .getElementById("app")
      .classList.remove(
        "mobile-home",
        "mobile-ugc",
        "mobile-center",
        "mobile-com",
        "mobile-development",
        "mobile-feedback",
        "home",
        "ugc",
        "center",
        "com",
        "development",
        "feedback"
      );
    document.getElementById("app").classList.add(contentClass.value);
  }
};

const init = async () => {
  initClass();
  document.title = langData.pageTitle;
  document.documentElement.lang = getLangCode(curLang);
  viewPageStartTime.value = new Date();

  // 根据当前页面类型设置埋点事件类型
  const getEventType = (tab) => {
    switch (tab) {
      case "ugc":
        return "UGC创作";
      case "center":
        return "作品管理";
      case "home":
      default:
        return "首页";
    }
  };

  window.activityDataLayer.push({
    eventName: "view_page",
    eventType: getEventType(activeNavTab.value),
    aid: window.activity_name,
    gameId: window.game_id,
  });
  try {
    let loginRes = await getJSON(getUserJsonApi(platform.value));
    if (!+loginRes.result) {
      return;
    }
    isLogin.value = true;
    accountName.value = loginRes?.data?.LOGIN_ACCOUNT || "";
    window.activityDataLayer.push({
      eventName: "login",
      uid: loginRes?.data?.UID,
      loginAccount: loginRes?.data?.LOGIN_ACCOUNT,
      aid: window.activity_name,
      gameId: window.game_id,
    });
  } catch (error) {
    console.error(error);
  }
};
init();
provide("init", init);
provide("isLogin", isLogin);
provide("accountName", accountName);
provide("platform", platform);

provide("gameId", gameId);
provide("isMobile", isMobile);
// 监听URL变化
const handleUrlChange = () => {
  const newPage = getInitialPage();
  if (newPage !== activeNavTab.value) {
    activeNavTab.value = newPage;
    initClass();
  }
};

// 监听浏览器前进后退
window.addEventListener("popstate", handleUrlChange);

// 提供给子组件的方法：更新URL参数
const updateUrlParam = (page) => {
  if (page === "home") {
    // 如果是home页面，移除mainPage参数
    const url = new URL(window.location);
    url.searchParams.delete("mainPage");
    window.history.pushState({}, "", url);
  } else {
    // 其他页面设置mainPage参数
    const url = new URL(window.location);
    url.searchParams.set("mainPage", page);
    window.history.pushState({}, "", url);
  }
};

provide("activeNavTab", activeNavTab);
provide("initClass", initClass);
provide("viewPageStartTime", viewPageStartTime);
provide("updateUrlParam", updateUrlParam);
</script>

<style lang="less">
@import url(./assets/less/common.less);
</style>
